import React, { useContext } from 'react';
import { useField, useForm } from 'react-final-form';
import cx from 'classnames';

import { HelpIcon } from '@motorway/mw-highway-code';

import { useBankDetailsFieldIntent } from '../AddBankDetails.helpers';
import { AddBankDetailsContext, AddBankDetailsContextType } from '../AddBankDetailsContext';

import { AddBankDetailsField, Intent } from './helpers/AddBankDetailsField';

import styles from './fields.scss';

export const ACCOUNT_HOLDER_NAME_FIELD_NAME = 'name';

export const AccountHolderName = () => {
  const { change } = useForm();
  const { input: { value }, meta } = useField(ACCOUNT_HOLDER_NAME_FIELD_NAME);

  const {
    accountNameErrorMessage, correctName, displayAccountNameCloseMatchMessage,
    displayAccountNameErrorMessage, providedName,
  }: AddBankDetailsContextType = useContext(AddBankDetailsContext);
  const currentIntent = useBankDetailsFieldIntent(ACCOUNT_HOLDER_NAME_FIELD_NAME);

  const isNameMatching = displayAccountNameErrorMessage ? value === providedName : value === correctName;
  const hasInputIntentShowState = !meta.active && !meta.validating;

  const displayCloseMatchTooltip = hasInputIntentShowState && displayAccountNameCloseMatchMessage && !isNameMatching;
  const displayAccountNameErrorTooltip = hasInputIntentShowState && displayAccountNameErrorMessage && isNameMatching;

  const onCorrectNameClick = () => {
    change(ACCOUNT_HOLDER_NAME_FIELD_NAME, correctName);
  };

  const feedbackTooltip = {
    ...(displayCloseMatchTooltip ? {
      content: (
        <>
          <span>Did you mean</span>
          {' '}
          <span className={cx('mw-link', styles.nameLink)} onClick={onCorrectNameClick}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onCorrectNameClick();
              }
            }}
            role="button"
            tabIndex={0}>
            {correctName}
          </span>
          ?
        </>
      ),
      theme: displayCloseMatchTooltip ? 'warning' : undefined,
      tooltipIcon: <span className={styles.warningIcon}><HelpIcon /></span>,
    } : {}),
    ...(displayAccountNameErrorTooltip ? { content: accountNameErrorMessage } : {}),
  };

  let intent: Intent;

  switch (true) {
  case displayCloseMatchTooltip:
    intent = 'warning';
    break;

  case displayAccountNameErrorTooltip:
    intent = 'error';
    break;

  default:
    intent = currentIntent;
  }

  return (
    <AddBankDetailsField
      {...{ feedbackTooltip, intent }}
      name={ACCOUNT_HOLDER_NAME_FIELD_NAME}
    />
  );
};
